import { cn } from '@/utils/tailwind';

export const LayoutTabSection = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'sticky top-0 z-[20] flex w-full flex-col gap-[16px] bg-gr-50  pt-[10px]',
        className,
      )}
    >
      {children}
    </div>
  );
};
